import { SuggestPendingCount } from '@oh-vcp/components-common';
import { useQuery } from 'react-query';
import apiService from './apiService';

const fetchSuggensPendingCount = async (
  type: string,
  profileId: number
): Promise<SuggestPendingCount> => {
  const response = await apiService.get(`/profiles/suggest/${type}/${profileId}/pending`, {
    headers: {
      Accept: 'text/plain'
    },
    responseType: 'text'
  });
  if (!response || !response.data) return { count: 0 };

  const suggestPendingCount: SuggestPendingCount = JSON.parse(response.data);
  return suggestPendingCount;
};

const useSuggestPendingCount = (type: string, profileId: number | undefined) => {
  return useQuery({
    enabled: !!type && !!profileId,
    queryFn: () => fetchSuggensPendingCount(type, profileId!),
    queryKey: ['useSuggestPendingCount', type, profileId],
    retry: 0
  });
};

export default useSuggestPendingCount;
